module.exports = __webpack_public_path__ + "static/img/areaA-16.c32627b.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/areaA-16.png
// module id = 936
// module chunks = 1